import { Component, Input, OnInit } from '@angular/core';
import { UserProfile } from 'src/app/models/profile.model';
import { MatDialog } from '@angular/material/dialog';
import { UpdateUserinfoDialogComponent } from '../update-userinfo-dialog/update-userinfo-dialog.component';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'profile-userinfo-field',
    templateUrl: './profile-userinfo-field.component.html',
    styleUrl: './profile-userinfo-field.component.scss',
    standalone: false
})
export class ProfileUserinfoFieldComponent implements OnInit {
  @Input() userInfo : UserProfile;
  @Input() isSubscribed: boolean;

  constructor(
    private readonly dialog: MatDialog,
    private readonly userService: UserService
  ){}

  ngOnInit(): void {
    this.reloadUserInfo();
  }

  reloadUserInfo(): void {
    this.userService.userInfo$.subscribe(profile => {
      if (profile != null) {
        this.userInfo = profile;
      }
    });
  }

  edit() : void {
    this.dialog.open<UpdateUserinfoDialogComponent>(
      UpdateUserinfoDialogComponent,
      {
        autoFocus: false, // To prevent select state of close button in header
        panelClass: 'medium',
        data: {
          userInfo: this.userInfo,
          isSubscribed: this.isSubscribed
        },
      }
    );
  }
}
